<template>
    <div v-if="pageLoader" class="no-data">
        <RotatingLoader :size="30" :speed="0.6" />
        <span>Loading Details...</span>
    </div>
    <div v-else class="create-crisis-ops-container">
        <div class="sb-header">
            <div v-if="!isCompleted && status !== 'DRAFT'" class="sb-header-completed">
                <div class="back-btn-wrap">
                    <button class="back-btn" @click="goHome()">
                        <img :src="require('@/assets/icons/back-arrow.svg')" alt="">
                    </button>
                    <span class="home-btn-title">Crisis Details</span>
                </div>

                <div class="button-container">
                    <!-- <button class="share-btn" @click="showShareMenu = true">
                        <div class="completed-wrappershare">
                            <img :src="require('@/assets/icons/share.svg')" />
                        </div>
                    </button> -->
                    <button class="generate-crisis" :disabled="downloadLoader" @click="downloadCrisis">
                        <div class="continue-btn">
                            <Svg :src="require('@/assets/icons/download.svg')" fill="white"></Svg>
                            <p>Download</p>
                            <v-progress-circular v-if="downloadLoader" indeterminate :size="18"
                                :width="2"></v-progress-circular>
                        </div>
                    </button>
                </div>
            </div>

            <div v-else :class="['sb-header-wrapper', { 'completed-header': isCompleted }]">
                <button v-if="!isCompleted && status === 'DRAFT'" class="home-btn" @click="popupType = 'goHome'">
                    <img :src="require('@/assets/icons/home.svg')" alt="">
                </button>
                <div class="header-title-wrapper">
                    <div class="header-title">
                        <span class="doc-title">{{ docTitle }}</span>
                        <RenamePopup v-if="isEditingTitle" :docName="docTitle" :isEditing="isEditingTitle"
                            :id="$route.params.crisisDocumentId" flowType="crisis"
                            @update-isEdit="isEditingTitle = $event" @updated-prTitle="docTitle = $event" />
                        <button class="edit-btn" @click="isEditingTitle = true">
                            <img :src="require('@/assets/icons/edit.svg')" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="status == 'DRAFT'" class="mid-container">
            <div class="input-brief-container row">
                <div class="form-section">
                    <div class="form-header">
                        <div class="header-txt">The Brief</div>
                        <div class="form-container">
                            <v-form class="comms-form" v-model="isFormValid" @submit.prevent>
                                <div class="form-label">
                                    <div class="input-wrapper" v-for="(ques, index) in staticQuestion.questions"
                                        :key="index">
                                        <div class="form-input">
                                            <div class="label">{{ ques.questionText }} <span v-if="ques.isRequired"
                                                    class="required">*</span></div>
                                            <v-text-field v-model="ques.answer" v-if="ques.responseType === 'text'"
                                                :rules="ques.isRequired ? fieldRules : []"
                                                :placeholder="ques.placeholderText || 'Give a short overview'"
                                                variant="outlined" density="compact"></v-text-field>
                                            <v-select v-else-if="ques.responseType === 'dropdown'" v-model="ques.answer"
                                                :items="templateList" item-title="templateName" item-value="templateId"
                                                :rules="ques.isRequired ? fieldRules : []"
                                                placeholder="Select a template" variant="outlined" density="compact" />

                                            <v-textarea v-model="ques.answer" :rules="ques.isRequired ? fieldRules : []"
                                                :placeholder="ques.placeholderText || 'Give a short overview'"
                                                variant="outlined" density="compact"
                                                v-else-if="ques.responseType === 'textarea'"></v-textarea>

                                            <v-menu v-model="ques.showDateMenu" :close-on-content-click="false" v-else>
                                                <template v-slot:activator="{ on, props }">
                                                    <div class="selected-date-container">
                                                        <v-text-field v-model="ques.displayDateVariable"
                                                            placeholder="Pick a date" readonly variant="outlined"
                                                            density="compact" v-on="on" v-bind="props"
                                                            :rules="ques.isRequired ? fieldRules : []"
                                                            class="date-field">
                                                            <template #append-inner>
                                                                <img :src="require('@/assets/icons/calendar.svg')"
                                                                    alt="">
                                                            </template>
                                                        </v-text-field>
                                                    </div>
                                                </template>
                                                <v-date-picker v-model="ques.answer" show-adjacent-months
                                                    :max="new Date()"
                                                    @update:model-value="(value) => updateDate(value, ques)"></v-date-picker>
                                            </v-menu>
                                        </div>
                                    </div>
                                </div>
                            </v-form>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <div v-else-if="status == 'COMPLETED'" class="completed-section">
            <CompletedCrisis :crisisData="crisisData" :isCompleted="isCompleted" v-model="docTitle"
                @download-version="updateVersionType" />
        </div>

        <div v-if="status == 'DRAFT'" class="footer">
            <div class="inner-footer">
                <div class="footer-action">
                    <button class="delete-pr" @click="handleDeletePr" v-if="!compareMode">
                        <img :src="require('@/assets/icons/delete.svg')" />
                    </button> &nbsp;&nbsp;&nbsp;
                    <button class="save-as-draft" @click="popupType = 'saveAsDraft'">
                        <img :src="require('@/assets/icons/save.svg')" />
                        <p>Save as Draft</p>
                    </button>
                </div>
                <div class="footer-btn">
                    <div class="footer-right">
                        <button class="generate-crisis" @click="handleGenerateClick"
                            :disabled="!isFormValid || pageLoader">
                            <p>Generate Response</p>
                            <img :src="require('@/assets/icons/next.svg')" alt="" />
                        </button>

                    </div>
                </div>
            </div>
        </div>
    </div>
    <v-overlay :model-value="isGenerate" class="overlay" persistent="true">
        <RotatingLoader :size="30" :speed="0.6" />
        <span>Generating</span>
    </v-overlay>
    <ConfirmPopup v-if="confirmPopup" v-model="confirmPopup" :title="popupData.title" :image="popupData.image"
        :type="popupData.type" />

    <CommonPopup v-if="showCommonPopup" :showCommonPopup="showCommonPopup" :popupType="popupType"
        @confirm-action="handlePopupConfirmation" />


</template>
<script>
import RenamePopup from '@/components/RenamePopup.vue';
import CommonPopup from '@/components/CommonPopup.vue';
import axiosInstance from '@/axiosInterceptor';
import { Eventbus } from '@/plugins/eventBus';
import CompletedCrisis from '@/views/CrisisManagement/CompletedCrisisDocument.vue';
import ConfirmPopup from '@/components/ConfirmPopup.vue';
import RotatingLoader from '@/components/CircularProgressBar.vue';
import { downloadPr } from '@/helper/downloadPr';
import InfoIcon from '@/assets/icons/clr-info-icon.svg';
import UpIcon from '@/assets/icons/up-icon.svg';
import DownIcon from '@/assets/icons/down-icon.svg';
import moment from 'moment-timezone';

export default {
    name: 'CrisisManagementDetails',
    components: {
        CommonPopup,
        RenamePopup,
        CompletedCrisis,
        ConfirmPopup,
        RotatingLoader
    },
    data() {
        return {
            liveDraft: "",
            isEditingTitle: false,
            isListening: false,
            saveDraftLoader: false,
            pageLoader: false,
            isGenerate: false,
            isFormValid: false,
            originalTitle: "New Title",
            isOpen: true,
            refreshkey: 0,
            fieldRules: [
                (v) => !!v || 'This field is required'
            ],
            InfoIcon,
            showCommonPopup: false,
            downloadLoader: false,
            confirmPopup: false,
            popupType: null,
            deleteImage: require('@/assets/icons/delete_red.svg'),
            staticQuestion: {
                questions: [{
                    question: "What’s the story you’re trying to tell?",
                    answer: ""
                }]
            },
            isGenerate: false,
            crisisDocumentId: null,
            crisisData: [],
            docTitle: null,
            isEditing: false,
            inputBriefStatus: 'static',
            isFinalPage: false,
            deleteLoader: false,
            isCompleted: false,
            isRecording: false,
            uploadtext: null,
            isFileSelected: false,
            isAudioProcessing: false,
            audioProcessStatus: null,
            status: null,
            templateList: [],
            isEditingTitle: false,
            popupData: {},
            versionType:null,
            InfoIcon, UpIcon, DownIcon
        }
    },
    computed: {

    },
    watch: {
        popupType() {
            if (this.popupType) {
                this.showCommonPopup = true;
            }
        },
    },
    methods: {
        updateVersionType(val) {
            this.versionType = val
        },
        updateDate(date, ques) {
            ques.displayDateVariable = moment(date).format('DD-MM-YYYY');
            ques.showDateMenu = false;
        },
        async getCrisisDetails(isFallback = false) {
            if (!isFallback) {
                this.pageLoader = true;
            }

            try {

                const response = await axiosInstance.get(`/crisis/${this.$route.params.crisisDocumentId}`);

                this.crisisData = response.data.data;
                this.docTitle = this.crisisData.title;
                this.status = this.crisisData.status;

                if (this.status === "DRAFT") {
                    if (this.crisisData.responseObjectWithQuestionId) {
                        this.staticQuestion.questions = this.crisisData.responseObjectWithQuestionId;
                    } else {
                        await this.fetchQuestions();
                    }
                    await this.fetchTemplates();
                }

            } catch (error) {
                Eventbus.emit('commonSnackbar', {
                    snackType: 'error',
                    message: 'Error fetching message house details',
                });

            } finally {
                this.pageLoader = false;
            }
        },

        async fetchTemplates() {
            try {
                const response = await axiosInstance.get(`/crisis/template`);
                this.templateList = response.data.data;
            } catch (error) {
                console.error("Fetch templates failed", error);
                throw error;
            }
        },

        async handleGenerateClick() {
            this.isGenerate = true;
            try {
                await this.saveAsDraft();

                let payload = {
                    crisisDocumentId: this.crisisDocumentId,
                }

                let response = await axiosInstance.put('/crisis/generate', payload)
                this.isCompleted = true;
                this.status = 'COMPLETED';
                this.crisisData.generatedContent = response.data.data;
            } catch (error) {
                console.error("Error generating PR Strategy", error);
                if (error.response?.status === 504 || error.code === 'ERR_NETWORK') {
                    let attempts = 0;
                    let maxAttempts = 40;
                    const intervalTime = 15000;
                    const intervalId = setInterval(async () => {
                        attempts++;
                        try {
                            let isFallback = true;
                            await this.getCrisisDetails(isFallback);
                            if (this.crisisData.status === "COMPLETED") {
                                clearInterval(intervalId);
                                this.isCompleted = true;
                                return;

                            } else if (attempts >= maxAttempts) {
                                clearInterval(intervalId);
                                Eventbus.emit('commonSnackbar', {
                                    snackType: 'warning',
                                    message: 'Message House generation is taking longer than expected. Please check again later.',
                                });
                            }
                        } catch (pollError) {
                            console.error("Error during polling:", pollError);
                            clearInterval(intervalId);
                            Eventbus.emit('commonSnackbar', {
                                snackType: 'error',
                                message: 'Failed to generate Message House. Please try again later.',
                            });

                        }
                    }, intervalTime);
                }

            } finally {
                this.isGenerate = false;
                this.refreshkey += 1;
            }
        },
        goHome() {
            this.$store.dispatch('updateIsGeneratePopup', false);
            this.$router.push({ name: 'CrisisManagementHome' });
        },
        editTitle() {
            this.isEditing = true;
        },
        handleDeletePr() {
            this.popupType = 'delete'
            this.showCommonPopup = true;
        },
        handleTitle(newTitle) {
            this.originalTitle = newTitle;
        },
        async downloadCrisis() {
            this.downloadLoader = true;
            let payload = {
                crisisDocumentId: this.crisisDocumentId,
                flowType: "CRISIS",
                versionType: this.versionType
            }
            let documentName = this.docTitle + '_'+ payload.versionType
            await downloadPr(payload, documentName);
            this.downloadLoader = false;
        },
        async handlePopupConfirmation(val) {
            this.showCommonPopup = false;
            if (val === 'yes') {
                if (this.popupType === 'delete') {
                    this.deleteLoader = true;
                    axiosInstance.put('/crisis/delete', { crisisDocumentId: this.$route.params.crisisDocumentId, })
                        .then((response) => {
                            if (response.status === 200) {
                                this.popupData = {
                                    title: 'Crisis Document Discarded',
                                    image: require('@/assets/icons/delete_red.svg'),
                                    type: 'success'
                                };
                                this.confirmPopup = true;
                                setTimeout(() => {
                                    this.confirmPopup = false;

                                    this.$router.push({ name: 'CrisisManagementHome' });
                                }, 1000);
                            }
                        })
                        .catch((error) => {
                            console.error('Error while deleting PR', error);
                            Eventbus.emit('commonSnackbar', {
                                snackType: "failed",
                                message: 'Failed to delete PR'
                            });
                        })
                        .finally(() => {
                            this.deleteLoader = false;
                        })
                }
                else if (this.popupType === 'saveAsDraft') {
                    this.saveDraftLoader = true;
                    let payload = {
                        crisisDocumentId: this.crisisDocumentId,
                        staticQuestions: this.staticQuestion.questions,
                    };
                    let response = await axiosInstance.put('/crisis/saveDraft', payload)
                    if (response.status == 200) {
                        this.popupData = {
                            title: 'Crisis saved as Draft',
                            image: require('@/assets/icons/success.svg'),
                            type: 'success'
                        };
                        this.confirmPopup = true;
                        setTimeout(() => {
                            this.confirmPopup = false;
                            this.$router.push({ name: 'CrisisManagementHome' });
                        }, 2000);

                    }
                    this.saveDraftLoader = false;
                }
                else {
                    this.$store.dispatch('updateIsGeneratePopup', false);
                    this.$router.push({ name: 'CrisisManagementHome' });
                }
            }
            this.popupType = null;
        },
        uploadFile() {
            this.$refs.fileInput.click();
        },
        async fetchQuestions() {

            try {
                const questionTypeResponse = await axiosInstance.get(`/crisis/type`);
                let crisisTypeid = questionTypeResponse.data?.data[0]?.typeId;
                if (!crisisTypeid) {
                    Eventbus.emit('commonSnackbar', {
                        snackType: "failed",
                        message: 'Failed to fetch crisis type'
                    });
                    return;
                }

                const response = await axiosInstance.get(`/crisis/questions/${crisisTypeid}`);
                this.staticQuestion.questions = response.data.data;
                const sortByOrder = (array) => {
                    return array?.sort((a, b) => a.orderNumber - b.orderNumber) || [];
                };

                if (this.staticQuestion.questions?.length > 0) {

                    this.staticQuestion.questions = sortByOrder(
                        this.staticQuestion.questions
                    );

                    this.staticQuestion.questions.forEach(item => {
                        item.answer = null;

                        if (item.responseType === 'date') {
                            item.showDateMenu = false;
                            item.displayDateVariable = null;
                        }
                    });
                }

            } catch (err) {
                console.error("Fetch questions failed", err);
                throw err;
            }
        },
        async saveAsDraft() {
            let payload = {
                crisisDocumentId: this.crisisDocumentId,
                staticQuestions: this.staticQuestion.questions,
            };
            await axiosInstance.put('/crisis/saveDraft', payload)
                .then((response) => {
                })
                .catch((error) => {
                    Eventbus.emit('commonSnackbar', {
                        snackType: "failed",
                        message: 'Failed to save as draft'
                    });
                });
        }
    },
    async mounted() {
        this.pageLoader = true;
        this.crisisDocumentId = this.$route.params.crisisDocumentId;
        await this.getCrisisDetails();
        this.pageLoader = false;
    }
}
</script>
<style scoped>
.no-data {
    width: 100%;
    height: 100%;
    padding: 2rem;
    gap: 20px;
    display: flex;
    overflow: auto;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #FFFFFF;
}

.textarea-wrapper {
    position: relative;
}

.textarea-grow {
    flex: 1;
    display: flex;
    position: relative;
}

.create-crisis-ops-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    background: var(--dark-background);
    background-size: 100% 100%;
}

.create-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    background: var(--dark-background);
    background-size: 100% 100%;
}

.sb-header {
    position: sticky;
    top: 0;
    background: #FFFFFF14;
    color: white;
    z-index: 100;
    padding: 1rem 1.5rem;
}

.sb-header-completed {
    display: flex;
    justify-content: space-between;
    gap: 4.5rem;
}

.sb-header-wrapper {
    width: 54%;
    display: flex;
    justify-content: space-between;
    gap: 4.5rem;
}


.completed-header {
    width: 100%;
    display: flex;
    justify-content: center;
    gap: 4.5rem;
}


.header-left {
    display: flex;
    flex-direction: row;
    gap: 0.75rem;
    justify-content: center;
    align-items: center;
}

.header-txt {
    font-size: 24px;
    font-weight: 600;
    text-align: left;
    color: #FAFAFA;
    font-family: monospace;
    padding: 4px;

}

.back-btn-wrap {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    justify-content: center;
    align-items: center;
}

.back-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #FFFFFFFF;
    border-radius: 50%;
    height: 2.5rem;
    width: 2.5rem;
}

.home-btn-title {
    font-weight: 500;
    text-align: center;
    font-size: 18px;
}



.button-container {
    display: flex;
    flex-direction: row;
    gap: 1rem;
}

.share-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 12px;
    gap: 12px;
    border-radius: 8px;
    border: 1px solid #FFFFFF33;
}


.completed-wrappershare {
    display: flex;
    align-items: center;
    gap: 0.5em;
}

.continue-btn {
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
}

.header-title-wrapper {
    display: flex;
    justify-content: space-between;
}


.header-title {
    display: flex;
    align-items: center;
    gap: 16px;
    color: white;
}


.doc-title {
    font-weight: 500;
    text-align: center;
}

.dropdown {
    display: flex;
    flex-direction: row !important;
}

.dropdown-container {
    display: flex;
    flex-direction: row !important;
    width: 50%;
}

.header-right {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px;
    padding: 12px;
}

.share-wrapper {
    all: unset;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px 12px 8px 12px;
    gap: 12px;
    border-radius: 8px;
    border: 1px solid #FFFFFF33;
}

.icon-wrapper {
    display: flex;
    align-items: center;
    gap: 0.5em;
    cursor: pointer;
}

.download {
    background: linear-gradient(90deg, #FF00C3, #FF0A19, #FF7800);
    color: #FFFFFF;
}

.crisis-title {
    font-weight: 500;
    text-align: center;
}

.edit-title-input {
    width: 200px;
    align-items: center;
}

.edit-btn {
    display: flex;
    padding: 8px 8px;
    border-radius: 8px;
    border: 1px solid #FFFFFF33;
    align-items: center;
    cursor: pointer;
}

.delete-pr {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 12px;
    gap: 12px;
    border-radius: 8px;
    border: 1px solid #FFFFFF33;
}

.overlay {
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: white;
    z-index: 9999;
}

.home-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #FFFFFF1F;
    border-radius: 8px;
    padding: 10px;
}

.header_box {
    width: 5%;
    display: flex;
    flex-direction: row;
    justify-content: center;
}

.top_header_rename {
    width: 95%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.completed-section {
    display: flex;
    height: 100%;
    overflow: hidden;
    flex-direction: column;
    align-items: center;
}

.generate-crisis {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    padding: 8px 20px;
    border-radius: 8px;
    background: var(--primary-gradient);
}

.generate-crisis :disabled {
    background: var(--primary-gradient-with-black);
}

.footer-right {
    display: flex;
    gap: 12px;
    align-items: center;
}

.footer {
    position: sticky;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 16px 48px;
    background: #180914;
    border-top: 1px solid #FFFFFF33;
    color: white;
    z-index: 100;
}

.footer--disabled {
    pointer-events: none;
    opacity: 0.5;
    filter: grayscale(0.8);
}

.inner-footer {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.footer-action {
    display: flex;
    flex-direction: row;
    width: 50%;
}

.footer-btn {
    width: 50%;
    max-width: 1024px;
    display: flex;
    justify-content: flex-end;
}

.mid-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    scrollbar-width: thin;
    will-change: transform;
}

.input-brief-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    flex: 1;
}

.row {
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    padding: 2rem 16rem;
}

.textarea-actions {
    display: flex;
    flex-direction: row;
    gap: 6px;
}

.form-section {
    width: 80%;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    flex: 1;
}

.form-header {
    border-radius: 8px 8px 0 0;
}

.form-header h2 {
    color: white;
    font-size: 20px;
    font-weight: 500;
}

.label {
    font-size: 16px;
    font-weight: 500;
    text-align: left;
    color: #171717;
}

.dropdown-label {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    font-weight: 500;
    text-align: center;
    color: #171717;
    height: 2.5rem;
}

.comms-form {
    display: flex;
    flex-direction: column;
    padding: 40px;
    gap: 40px;
    border-radius: 24px;
    background: #FAFAFA;
}

.form-label {
    display: flex;
    flex-direction: column;
    gap: 1em;
}

.form-input {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.save-as-draft {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px 24px 8px 24px;
    gap: 12px;
    border-radius: 8px;
    border: 1px solid #FFFFFF33;
}

.date-field :deep(input:hover) {
    cursor: pointer !important;
}
</style>